export const HOME = '/';
export const ABOUT = '/about';
export const PROJECTS = '/projects';
export const EXPERIENCE = '/experience';
export const BLOG = '/blog';
export const RESUME = '/resume.pdf';


// WEBPACK FOOTER //
// ./src/constants/routes.js